module.exports = __webpack_public_path__ + "img/5.c09d0cf5.webp";